import React from 'react';

/**
 * Shown in customer call popups when more than the main number is saved.
 */
export default function CustomerDialNumberPicker({ options, value, onChange }) {
  if (!options || options.length < 2) return null;

  return (
    <div style={{ margin: '12px 0', textAlign: 'left' }}>
      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6, color: '#374151' }}>
        Which number?
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {options.map((opt) => {
          const selected = String(value || '').replace(/\D/g, '').slice(-10)
            === String(opt.phone).replace(/\D/g, '').slice(-10);
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => onChange(opt.phone)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 2,
                padding: '8px 10px',
                borderRadius: 8,
                border: selected ? '1px solid #2563eb' : '1px solid #e5e7eb',
                background: selected ? '#eff6ff' : '#fff',
                cursor: 'pointer',
                textAlign: 'left',
              }}
            >
              <span style={{ fontSize: 12, fontWeight: 600, color: '#111827' }}>
                {opt.label || 'Number'}
              </span>
              <span style={{ fontSize: 13, color: '#374151' }}>{opt.phone}</span>
              {opt.remark ? (
                <span style={{ fontSize: 12, color: '#6b7280' }}>{opt.remark}</span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
